import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { IonicStorageModule, StorageConfig } from '@ionic/storage-angular';
import { StorageService } from './storage.service';

@NgModule({
  imports: [IonicStorageModule],
})
export class StorageModule {
  static forRoot(config: StorageConfig): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: ([StorageService] as Provider[]).concat(IonicStorageModule.forRoot(config).providers),
    };
  }
}
